module.exports = __webpack_public_path__ + "img/kaitz_yes.50794881.png";